import { render, staticRenderFns } from "./UsersTable.vue?vue&type=template&id=74b474cc&scoped=true"
import script from "./UsersTable.vue?vue&type=script&lang=js"
export * from "./UsersTable.vue?vue&type=script&lang=js"
import style0 from "../../components/dataIterator/TableCustomSort.scss?vue&type=style&index=0&id=74b474cc&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b474cc",
  null
  
)

export default component.exports